export default __webpack_public_path__ + "static/media/photo 4.1c6a813c.jpg";